/**
 * Typescript pattern to ensure exhaustive checks in switch/unions.
 *
 * See https://www.typescriptlang.org/docs/handbook/advanced-types.html
 */
export function assertNever(x: never, msg?: string): never {
  // tslint:disable-next-line:no-console
  console.log(msg || 'unexpected object:', x);
  throw new Error(`${msg || 'unexpected object:'} ${x}`);
}

/** Permissive type that is not any */
export type Unknown = {} | null;

/** A union member */
export type UnionMember = { kind: string } | number;

/**
 * Omits properties from a type.
 * See: https://www.typescriptlang.org/docs/handbook/advanced-types.html
 */
export type Omit<T, K> = Pick<T, Exclude<keyof T, K>>;



// WEBPACK FOOTER //
// ./src/util/types.ts